import HttpLog from "./HttpLog";
import NewRelick from "./NewRelick";
import Splunk from "./Splunk";
import Sumologic from "./SumoLogic";
import Syslog from "./Syslog";
import { FormConfigType } from "./type";

/**
 * Get the values from this integration data that will be used to
 * prepoluate the input fields
 * @param configs configuration that identifies the structure of the integration input
 * @param data the ingegration data
 * @param dataAdapter a custom function that is used to adapt complex values to it simplest form
 */
export const getInitialValue = (
  configs: FormConfigType[],
  data: any = {},
  dataAdapter?: (configId: string, data: any, idValue: any) => any
) => {
  return configs.reduce(
    (values, cfg) => {
      if (dataAdapter) {
        const idValue = data?.[cfg.id] || cfg.value;
        values[cfg.id] = dataAdapter(cfg.id, data, idValue);
      } else {
        values[cfg.id] = data?.[cfg.id] || cfg.value;
      }
      return values;
    },
    {} as Record<string, any>
  );
};

export const observabilitySuitIntegrationForms = {
  newrelic: NewRelick,
  splunk: Splunk,
  syslog: Syslog,
  sumologic: Sumologic,
  httplog: HttpLog
};
